// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__6nyWa","namePhoneContainer":"style_namePhoneContainer__PbWu2"};